module.exports = __webpack_public_path__ + "assets/images/37YxXNgrvP.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/index/jiaotong.png
// module id = 2180
// module chunks = 0